import { NextPlan } from "@mui/icons-material";
import { GET_LIVE_SESSIONS, GET_LIVECLASS_PACKAGES, GET_VENDORS } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export type nl3PackageSchedulesFilter = {
  
  nlearn3LiveclassPackageIds: string;
  liveSessionId: string;
  status: string;
  isActive: string;
  meetingTitle: string;
  cancelled_at: [Date | null, Date | null];
  completed_at: [Date | null, Date | null];
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
  scheduled_start_time: [Date | null, Date | null];
  scheduled_end_time: [Date | null, Date | null];
};

export const nl3PackageSchedulesInitialValues: nl3PackageSchedulesFilter = {

  nlearn3LiveclassPackageIds: "",
  liveSessionId: "",
  status: "",
  isActive: "",
  meetingTitle:"",
  cancelled_at: [null, null],
  completed_at: [null, null],
  created_at: [null, null],
  updated_at: [null, null],
  scheduled_start_time: [null, null],
  scheduled_end_time: [null, null],
};

export const nl3PackageSchedulesMandatoryFields = [];

export const nl3PackageSchedulesValidationSchema = Yup.object().shape({
  created_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  updated_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  cancelled_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  completed_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  scheduled_start_time: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  scheduled_end_time: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
});

export const nl3PackageSchedulesProperties = [
  // {
  //   id: "nlearn3LiveclassPackageIds",
  //   type: "multi-select-dependency",
  //   label: "Liveclass Package",
  //   list: "nl3_liveclass_packages_gq", //because of multi-select
  //   keyValue: { label: "nameWithCount", value: "id" },
  //   fieldKeyLists: {},
  //   options: [],
  //   breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
  //   required: true,
  // },
  {
    id: "nlearn3LiveclassPackageIds",
    type: "multi-select-search",
    label: "Liveclass Package",
    keyValue: { label: "name", value: "id" },
    query: GET_LIVECLASS_PACKAGES,
    gqlKey: "getLiveclassPackages",
    dataKey: "liveclassPackages",
    searchFieldKey: "searchName",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,  
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Scheduled", value: "scheduled" },
      { label: "Completed", value: "completed" },
      { label: "Inprogress", value: "inprogress" },
      { label: "Cancelled", value: "cancelled" },
    ],
    hideNone: false,
  },
  {
    id: "isActive",
    type: "normal-select",
    label: "Is Active",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
    hideNone: false,
  },
  {
    id: "meetingTitle",
    type:"text",
    label:"Meeting Title",
    Placeholder:"Enter Meeting Title",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "cancelled_at",
    type: "date-range-picker",
    label: "Cancelled Between",
    Placeholder: "Select Cancelled Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "completed_at",
    type: "date-range-picker",
    label: "Completed Between",
    Placeholder: "Select Completed Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    Placeholder: "Select Updated Date Range",
    className: "updated-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "scheduled_start_time",
    type: "date-range-picker",
    label: "Scheduled Start Between",
    Placeholder: "Select Scheduled Start Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "scheduled_end_time",
    type: "date-range-picker",
    label: "Scheduled End Between",
    Placeholder: "Select Scheduled End Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
